module.exports = __webpack_public_path__ + "static/media/finOpsWhite.d6784852.svg";